import axios from 'axios'

import { CRYPTO_KEY } from '@/fixtures/Hash'
import router from '@/router'
import store from '@/store'

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_URL}/api`,
  timeout: 500000
})

instance.interceptors.request.use(req => {
  if (req.url !== '/auth/login') {
    req.headers['Authorization'] = `Bearer ${store.getters['Auth/token']}`
  }
  return req
})

const refresh = async (originalRequest) => {
  try {
    const { data } = await instance.post('/auth/refresh-token', {
      token: store.getters['Auth/token'],
      refreshToken: store.getters['Auth/refreshToken']
    })
    store.commit('Auth/SET_TOKEN', CryptoJS.AES.encrypt(data.token, CRYPTO_KEY).toString())
    store.commit('Auth/SET_REFRESH_TOKEN', CryptoJS.AES.encrypt(data.refreshToken, CRYPTO_KEY).toString())
    return instance({
      ...originalRequest,
      headers: {
        Authorization: `Bearer ${store.getters['Auth/token']}`,
        'Content-Type': 'application/json'
      }
    })
  } catch (err) {
    await store.dispatch('Auth/reset')
    await router.push({
      name: 'Login',
      replace: true
    })
    return Promise.reject(err)
  }
}

instance.interceptors.response.use(
  response => (response.data.code >= 400 && response.data.code < 600)
    ? Promise.reject(response)
    : response,
  error => {
    // Safari can't get the OK response and shows 'Network Error' instead
    const safariUnrealError = error.code === undefined && error.message === 'Network Error'
    const nonSafariUnauthorized = error.response && error.response.status === 401
    // Safari don't have response on error 4xx
    const safariUnauthorized = !error.response
    const refreshRequest = error.config.url.endsWith('/auth/refresh-token')
    const loginRequest = error.config.url.endsWith('/auth/login')
    const logoutRequest = error.config.url.endsWith('/auth/logout')
    const internalServerError = error.response.status === 500
    const badRequestError = error.response.status === 400
    const sessionInvalid = error.response.status === 440

    if (loginRequest) {
      return Promise.reject(error.response || error)
    } else if (safariUnrealError) {
      return Promise.resolve()
    } else if ((nonSafariUnauthorized || safariUnauthorized) && !refreshRequest) {
      return refresh(error.config)
    } else if (sessionInvalid) {
      return refresh(error.config)
    } else if (logoutRequest && badRequestError) {
      return Promise.resolve()
    } else if (internalServerError) {
      return Promise.reject(error.response || error)
    } else if (badRequestError) {
      return Promise.reject(error.response || error)
    }

    return Promise.reject(error.response || error)
  }
)

export default instance
